<div class="teammate-search-container">
  <mat-card class="search-card">
    <mat-card-header>
      <mat-card-title>Teammate Search</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="teammateSearchForm" (ngSubmit)="onSearch()">
        <div class="search-section">
          <h3>Search by Teammate Username</h3>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Teammate Username</mat-label>
            <input matInput formControlName="teammateId" placeholder="Enter teammate username">
            <mat-error *ngIf="teammateSearchForm.get('teammateId')?.hasError('required')">
              Teammate username is required
            </mat-error>
          </mat-form-field>
        </div>
        
        <div class="search-button-container">
          <button 
            mat-raised-button 
            color="primary" 
            type="submit" 
            [disabled]="isSearchDisabled || isLoadingFacilityRoles || isLoadingTeammateInformation">
            <mat-icon *ngIf="isLoadingFacilityRoles || isLoadingTeammateInformation">refresh</mat-icon>
            {{ (isLoadingFacilityRoles || isLoadingTeammateInformation) ? 'Searching...' : 'Search' }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
  <ng-container *ngIf="teammateID">
    <app-teammate-information [teammateID]="teammateID" (isLoadingInformation)="onTeammateInformationLoaded($event)"></app-teammate-information>
    <app-teammate-facility-roles [teammateID]="teammateID" (isLoadingRoles)="onFacilityRolesLoaded($event)"></app-teammate-facility-roles>
  </ng-container>
</div>
